module.exports = __webpack_public_path__ + "img/136.66386695.png";